export const RECEIVED_USER ='user/RECEIVED_USER';

export const CREATE_USER_SUCCESS = 'user/CREATE_USER_SUCCESS';

export const EDIT_USER_SUCCESS = 'user/EDIT_USER_SUCCESS';

export const RECEIVED_CURRENT_USER = 'user/RECEIVED_CURRENT_USER';

export const UPDATE_CURRENT_USER_PERMISSION = 'user/UPDATE_CURRENT_USER_PERMISSION';

export const REQUEST_GET_USER = 'user/REQUEST_GET_USER';

export const RECEIVED_SEARCHED_USER = 'user/RECEIVE_SEARCHED_USER';

export const REQUEST_GET_MY_TEAM = 'user/REQUEST_GET_MY_TEAM';

export const RECEIVED_MY_TEAM = 'user/RECEIVED_MY_TEAM';

export const CLER_TEAM_EMPTY = 'user/CLER_TEAM_EMPTY';
export const REQUEST_CURRENT_USER = 'user/REQUEST_CURRENT_USER';
export const LOGOUT = 'user/LOGOUT';